class productCardReview extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    fetch(this.attributes.src.value)
      .then(res => {
        return res.text();
      })
      .then(res => {
        let scriptText = res;
        const regex = /tag\.innerHTML\s*=\s*`(.*?)`;/s;
        const match = scriptText.match(regex);
        if (!match) return;
        document.querySelector(`#${this.attributes.rid.value}`).innerHTML = match[1];

    })
  }
}

customElements.define("product-card-review", productCardReview);